module.exports = __webpack_public_path__ + "static/media/cover-dakar.89f667d2.png";